import { IApplicationState } from '../../types/redux';

export const selectCurrentPage = (state: IApplicationState) => {
  return state.listingOffers.page;
};
